/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GenerateSettingsBioApiArg, SettingsGenerateBioResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateSettingsBio: build.mutation<SettingsGenerateBioResponse, GenerateSettingsBioApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/settings/profile/generate-bio`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as generateSettingsBioApi };
export const { useGenerateSettingsBioMutation } = injectedRtkApi;
